import i18n from '@/i18n'
import api from './api'

const TP_URL = process.env.VUE_APP_THIRD_PARTY_API_URL
const LIA_URL_PREFIX = '/google_ads/localinventoryads'
const GSEARCH_URL_PREFIX = '/google_ads/search'

export const MIN_ROAS_GOAL = 0.01
export const MAX_ROAS_GOAL = 1000

export const STRATEGY_VALUES = {
  MANUAL_CPC: 'Manual CPC',
  ENHANCED_CPC: 'Enhanced CPC',
  MAX_CLICKS: 'Maximize clicks',
  ROAS_GOAL: 'ROAS Goal',
  MAX_CONVERSIONS: 'Maximize conversions',
  MAX_ROAS: 'Maximize ROAS'
}

export const STRATEGY_OPTIONS_LIA = [
  { label: i18n.t('STRATEGY_MANUAL_CPC'), value: STRATEGY_VALUES.MANUAL_CPC },
  { label: i18n.t('STRATEGY_ENHANCED_CPC'), value: STRATEGY_VALUES.ENHANCED_CPC },
  { label: i18n.t('STRATEGY_MAXIMIZE_CLICKS'), value: STRATEGY_VALUES.MAX_CLICKS },
  { label: i18n.t('STRATEGY_ROAS_GOAL'), value: STRATEGY_VALUES.ROAS_GOAL }
]

export const STRATEGY_OPTIONS_SEARCH = [
  { label: i18n.t('STRATEGY_MAXIMIZE_CONVERSIONS'), value: STRATEGY_VALUES.MAX_CONVERSIONS },
  // { label: i18n.t('STRATEGY_MAXIMIZE_ROAS'), value: STRATEGY_VALUES.MAX_ROAS },
  { label: i18n.t('STRATEGY_MAXIMIZE_CLICKS'), value: STRATEGY_VALUES.MAX_CLICKS }
]

export const PRIORITY_OPTIONS = [
  { label: i18n.t('PRIORITY_HIGH'), value: 2 },
  { label: i18n.t('PRIORITY_MEDIUM'), value: 1 },
  { label: i18n.t('PRIORITY_LOW'), value: 0 }
]

export const GOOGLE_SEARCH_NETWORKS = [
  { id: 'Google Search', label: 'Google Search', value: 'Google Search' }
  // { id: 'Search Network', label: 'Search Network', value: 'Search Network' },
  // { id: 'Partner Search Network', label: 'Partner Search Network', value: 'Partner Search Network' },
  // { id: 'Content Network', label: 'Content Network', value: 'Content Network' }
]

export const KEYWORD_LEVELS = ['categories', 'subcategories', 'keywords', 'keywords-inner']

// eslint-disable-next-line
const MOCK_KEYWORDS = (level) => [
  { id: 1, name: `${level.toUpperCase()} 1` },
  { id: 2, name: `${level.toUpperCase()} 2` },
  { id: 3, name: `${level.toUpperCase()} 3` },
  { id: 4, name: `${level.toUpperCase()} 4` }
]

export default {
  async getMerchants (shopId) {
    const data = await api.get(`${LIA_URL_PREFIX}/merchants?shop_id=1`).then(res => res.data)
    const options = data && data.merchant_centers
    return options.map(opt => ({
      label: opt.account_name,
      value: opt.id
    }))
  },
  async getKeywords (level, parentCategory) {
    if (KEYWORD_LEVELS.indexOf(level) === -1) {
      throw new Error(`[googleAdsService.js] Invalid level for getKeywords. Valid levels are ${KEYWORD_LEVELS}`)
    }

    const url = `${GSEARCH_URL_PREFIX}/${level}${parentCategory ? `/${parentCategory}` : ''}`
    const _data = await api.get(url).then(res => res.data[level])
    // const data = MOCK_KEYWORDS(level)

    const withLevel = _data.map((d) => ({
      id: d.id || d.text,
      name: d.name || d.text,
      level
    }))

    return withLevel
  },
  async login () {
    await api.get(`${TP_URL}/dentsu/login`)
  }
}
